import './flowbite.css';

// core components
import './components/collapse';
import './components/dropdown';
import './components/tabs';
import './components/modal';
import './components/tooltip';
